<template>
  <div class="h5-page">
    <div class="h5-header">扫码入库</div>
    <div class="h5-body">
      <div class="h5-card">
        <p class="scan-tip">
          扫描或长按识别供应商出示的出库二维码，将识别内容复制粘贴到下方输入框提交，
          系统将自动为您生成采购入库单（生成后请在ERP中审核完成库存联动）。
        </p>
        <a-textarea
          v-model="qrContent"
          placeholder="请粘贴出库二维码内容（JSHOR|出库单号|防伪码）"
          :rows="4"
        />
        <a-button type="primary" block size="large" style="margin-top: 16px" :loading="loading" :disabled="!qrContent" @click="submit">
          确认入库
        </a-button>
      </div>
      <div v-if="result" class="h5-card result-card" :class=" result.already ? 'warn' : 'ok' ">
        <p class="result-title">{{ result.already ? '已处理过该出库单' : '扫码入库成功' }}</p>
        <p>采购入库单号：{{ result.cgrkBillNo }}</p>
        <p v-if="result.itemCount">商品数：{{ result.itemCount }}</p>
        <p v-if="result.totalPrice !== undefined">金额：￥{{ result.totalPrice }}</p>
        <p class="result-msg">{{ result.message }}</p>
      </div>
    </div>
    <h5-tab-bar active="scan" />
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { h5ScanInbound } from '@/api/plugin/orderReceive'
import H5TabBar from './H5TabBar'
import './h5-common.css'

export default {
  name: 'H5Scan',
  components: { H5TabBar },
  data() {
    return {
      qrContent: '',
      loading: false,
      result: null
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.result = null
      h5ScanInbound({ qrContent: this.qrContent.trim() }).then(res => {
        if (res.success) {
          this.result = res.data || {}
          this.qrContent = ''
        } else if (res.code === 401) {
          this.$router.replace('/h5/login')
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.scan-tip {
  color: #888;
  font-size: 13px;
  margin-bottom: 12px;
}
.result-card {
  border: 1px solid #b7eb8f;
}
.result-card.warn {
  border-color: #ffe58f;
}
.result-card p {
  margin: 4px 0;
  font-size: 14px;
}
.result-title {
  font-weight: 600;
  font-size: 16px;
}
.result-card.ok .result-title {
  color: #52c41a;
}
.result-card.warn .result-title {
  color: #faad14;
}
.result-msg {
  color: #888;
  font-size: 13px;
}
</style>
